import { Container, BtnPrimary, BtnGhost } from "../components/common";
import { useSeo } from "../lib/seo";

export default function NotFound() {
 useSeo({ title: "Page Not Found | RPM Auto Repair", description: "The page you're looking for doesn't exist.", path: "/404" });
 return (
 <Container className="flex min-h-[70vh] flex-col items-center justify-center py-24 text-center">
 <div className="font-display text-8xl font-700 text-primary sm:text-9xl">404</div>
 <h1 className="mt-4 font-display text-3xl text-white sm:text-4xl">This Road Leads Nowhere</h1>
 <p className="mt-4 max-w-md text-muted-foreground">The page you're looking for may have moved or no longer exists. Let's get you back on track.</p>
 <div className="mt-8 flex flex-col gap-4 sm:flex-row">
 <BtnPrimary to="/">Back to Home</BtnPrimary>
 <BtnGhost to="/services">Browse Services</BtnGhost>
 </div>
 </Container>
 );
}
